import { Navigate, useLocation } from 'react-router-dom';
import { DESK_REDIRECTS_ON, legacyDeskTarget } from '../../config/desk';

/**
 * An old page behind the desk's redirect switch.
 *
 * While `DESK_REDIRECTS_ON`, a URL the Alpha Desk replaces (`/stock-alpha/*`,
 * `/stocks/:symbol`) goes to its tab with the context mapped —
 * `/stock-alpha/why?sym=X` → `/desk/stock/overview?symbol=X` — so every link
 * and bookmark written against the old pages keeps working. Off, the old page
 * renders as it always did. The redirect is `replace`, so Back does not
 * bounce between the two.
 */
export default function LegacyRedirect({ children }) {
  const { pathname, search } = useLocation();
  const target = DESK_REDIRECTS_ON ? legacyDeskTarget(pathname, search) : null;
  if (target) return <Navigate to={target} replace />;
  return children;
}
